/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AffectedAddressApiClientService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.dev.psps714.com/affected-address-service";
    }

    /**
     * @return 200 response
     */
    getActiveAddresses(getActiveAddressesRequest: GetActiveAddressesRequest): Observable<ActiveAddressesResponse> {
        let url_ = this.baseUrl + "/active-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getActiveAddressesRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveAddresses(<any>response_);
                } catch (e) {
                    return <Observable<ActiveAddressesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActiveAddressesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveAddresses(response: HttpResponseBase): Observable<ActiveAddressesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ActiveAddressesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveAddressesResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    activeAddresses(): Observable<void> {
        let url_ = this.baseUrl + "/active-addresses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveAddresses(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActiveAddresses(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
     adHocNotificationPost(adHocNotificationPostRequest: AdHocNotificationPostRequest): Observable<AdHocNotificationPostResponse> {
        let url_ = this.baseUrl + "/ad-hoc-notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(adHocNotificationPostRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdHocNotificationPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdHocNotificationPost(<any>response_);
                } catch (e) {
                    return <Observable<AdHocNotificationPostResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdHocNotificationPostResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAdHocNotificationPost(response: HttpResponseBase): Observable<AdHocNotificationPostResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdHocNotificationPostResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdHocNotificationPostResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    adHocNotification(): Observable<void> {
        let url_ = this.baseUrl + "/ad-hoc-notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdHocNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdHocNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAdHocNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    postAffectedAddress(postAffectedAddressRequest: PostAffectedAddressRequest): Observable<PostAffectedAddressResponse> {
        let url_ = this.baseUrl + "/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postAffectedAddressRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAffectedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAffectedAddress(<any>response_);
                } catch (e) {
                    return <Observable<PostAffectedAddressResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PostAffectedAddressResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPostAffectedAddress(response: HttpResponseBase): Observable<PostAffectedAddressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PostAffectedAddressResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PostAffectedAddressResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    address(): Observable<void> {
        let url_ = this.baseUrl + "/address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getAddressAttribute(index: string, property: string): Observable<AddressAttributeResponse> {
        let url_ = this.baseUrl + "/address-attribute?";
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined and cannot be null.");
        else
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        if (property === undefined || property === null)
            throw new Error("The parameter 'property' must be defined and cannot be null.");
        else
            url_ += "property=" + encodeURIComponent("" + property) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressAttribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressAttribute(<any>response_);
                } catch (e) {
                    return <Observable<AddressAttributeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressAttributeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressAttribute(response: HttpResponseBase): Observable<AddressAttributeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddressAttributeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressAttributeResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    addressAttribute(): Observable<void> {
        let url_ = this.baseUrl + "/address-attribute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressAttribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressAttribute(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddressAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getAddressHistory(id: string): Observable<AddressHistoryResponse> {
        let url_ = this.baseUrl + "/address-history/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressHistory(<any>response_);
                } catch (e) {
                    return <Observable<AddressHistoryResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressHistoryResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressHistory(response: HttpResponseBase): Observable<AddressHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddressHistoryResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressHistoryResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    addressHistory(id: string): Observable<void> {
        let url_ = this.baseUrl + "/address-history/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressHistory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddressHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getAffectedAddress(id: string[]): Observable<AffectedAddressResponse> {
        let url_ = this.baseUrl + "/affected-address?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAffectedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAffectedAddress(<any>response_);
                } catch (e) {
                    return <Observable<AffectedAddressResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AffectedAddressResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAffectedAddress(response: HttpResponseBase): Observable<AffectedAddressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AffectedAddressResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AffectedAddressResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    affectedAddress(): Observable<void> {
        let url_ = this.baseUrl + "/affected-address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAffectedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAffectedAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAffectedAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    affectedAddresses(): Observable<void> {
        let url_ = this.baseUrl + "/affected-addresses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAffectedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAffectedAddresses(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAffectedAddresses(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    patchAffectedAddress(patchAffectedAddressRequest: PatchAffectedAddressRequest): Observable<BulkOperationResponse> {
        let url_ = this.baseUrl + "/affected-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patchAffectedAddressRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatchAffectedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatchAffectedAddress(<any>response_);
                } catch (e) {
                    return <Observable<BulkOperationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BulkOperationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPatchAffectedAddress(response: HttpResponseBase): Observable<BulkOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BulkOperationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BulkOperationResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    getAffectedArea(): Observable<AffectedAreaResponse> {
        let url_ = this.baseUrl + "/affected-area";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAffectedArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAffectedArea(<any>response_);
                } catch (e) {
                    return <Observable<AffectedAreaResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AffectedAreaResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAffectedArea(response: HttpResponseBase): Observable<AffectedAreaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AffectedAreaResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AffectedAreaResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    putAffectedArea(): Observable<void> {
        let url_ = this.baseUrl + "/affected-area";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAffectedArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAffectedArea(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutAffectedArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    affectedArea(): Observable<void> {
        let url_ = this.baseUrl + "/affected-area";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAffectedArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAffectedArea(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAffectedArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getAffectedAreaV2(): Observable<AffectedAreaResponseV2> {
        let url_ = this.baseUrl + "/affected-area-v2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAffectedAreaV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAffectedAreaV2(<any>response_);
                } catch (e) {
                    return <Observable<AffectedAreaResponseV2>><any>_observableThrow(e);
                }
            } else
                return <Observable<AffectedAreaResponseV2>><any>_observableThrow(response_);
        }));
    }

    protected processGetAffectedAreaV2(response: HttpResponseBase): Observable<AffectedAreaResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AffectedAreaResponseV2>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AffectedAreaResponseV2>(<any>null);
    }

    /**
     * @return 200 response
     */
    affectedAreaV2(): Observable<void> {
        let url_ = this.baseUrl + "/affected-area-v2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAffectedAreaV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAffectedAreaV2(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAffectedAreaV2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getBlockedAddresses(): Observable<GetBlockedAddressResponse> {
        let url_ = this.baseUrl + "/blocked-address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlockedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlockedAddresses(<any>response_);
                } catch (e) {
                    return <Observable<GetBlockedAddressResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBlockedAddressResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetBlockedAddresses(response: HttpResponseBase): Observable<GetBlockedAddressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetBlockedAddressResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBlockedAddressResponse>(<any>null);
    }

    /**
     * @return 207 response
     */
    blockAddress(postBlockedAddressRequest: PostBlockedAddressRequest): Observable<BulkOperationResponse> {
        let url_ = this.baseUrl + "/blocked-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postBlockedAddressRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockAddress(<any>response_);
                } catch (e) {
                    return <Observable<BulkOperationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BulkOperationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processBlockAddress(response: HttpResponseBase): Observable<BulkOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 207) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result207: any = null;
            result207 = _responseText === "" ? null : <BulkOperationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result207);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BulkOperationResponse>(<any>null);
    }

    /**
     * @return 207 response
     */
     deleteBlockedAddress(deleteBlockedAddressRequest: DeleteBlockedAddressRequest): Observable<BulkOperationResponse> {
        let url_ = this.baseUrl + "/blocked-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteBlockedAddressRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBlockedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBlockedAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkOperationResponse>;
        }));
    }

    protected processDeleteBlockedAddress(response: HttpResponseBase): Observable<BulkOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 207) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result207: any = null;
            result207 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkOperationResponse;
            return _observableOf(result207);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BulkOperationResponse>(null as any);
    }

    /**
     * @return 200 response
     */
    blockedAddress(): Observable<void> {
        let url_ = this.baseUrl + "/blocked-address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockedAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBlockedAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getPSPSEventStatus(): Observable<PSPSEventStatusResponse> {
        let url_ = this.baseUrl + "/event-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPSPSEventStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPSPSEventStatus(<any>response_);
                } catch (e) {
                    return <Observable<PSPSEventStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PSPSEventStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPSPSEventStatus(response: HttpResponseBase): Observable<PSPSEventStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PSPSEventStatusResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PSPSEventStatusResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    eventStatus(): Observable<void> {
        let url_ = this.baseUrl + "/event-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEventStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEventStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEventStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 204 response
     */
    putPSPSEventStatus(status: string): Observable<void> {
        let url_ = this.baseUrl + "/event-status/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPSPSEventStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPSPSEventStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPutPSPSEventStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    eventStatus2(status: string): Observable<void> {
        let url_ = this.baseUrl + "/event-status/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEventStatus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEventStatus2(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEventStatus2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getHealth(): Observable<HealthStatusResponse> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealth(<any>response_);
                } catch (e) {
                    return <Observable<HealthStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<HealthStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealth(response: HttpResponseBase): Observable<HealthStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <HealthStatusResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HealthStatusResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getMMessageConfig(): Observable<MMessageConfigResponse> {
        let url_ = this.baseUrl + "/mmessage-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMMessageConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMMessageConfig(<any>response_);
                } catch (e) {
                    return <Observable<MMessageConfigResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MMessageConfigResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMMessageConfig(response: HttpResponseBase): Observable<MMessageConfigResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MMessageConfigResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MMessageConfigResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
     putMMessageConfig(language: string, id: string, updateMMessageConfig: PutMMessageConfigRequest): Observable<MMessageConfig> {
      let url_ = this.baseUrl + "/mmessage-config/{id}/language/{language}";
      if (language === undefined || language === null)
          throw new Error("The parameter 'language' must be defined.");
      url_ = url_.replace("{language}", encodeURIComponent("" + language));
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(updateMMessageConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutMMessageConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutMMessageConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MMessageConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MMessageConfig>;
        }));
    }

    protected processPutMMessageConfig(response: HttpResponseBase): Observable<MMessageConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MMessageConfig;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MMessageConfig>(null as any);
    }

    /**
     * @return 200 response
     */
     postMMessageConfig(mMessageConfig: PostMMessageConfigRequest): Observable<MMessageConfig> {
        let url_ = this.baseUrl + "/mmessage-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mMessageConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostMMessageConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostMMessageConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MMessageConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MMessageConfig>;
        }));
    }

    protected processPostMMessageConfig(response: HttpResponseBase): Observable<MMessageConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MMessageConfig;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MMessageConfig>(null as any);
    }

    deleteMMessageConfig(language: string, id: string): Observable<void> {
      let url_ = this.baseUrl + "/mmessage-config/{id}/language/{language}";
      if (language === undefined || language === null)
          throw new Error("The parameter 'language' must be defined.");
      url_ = url_.replace("{language}", encodeURIComponent("" + language));
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ : any = {
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
          })
      };

      return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
          return this.processDeleteMMessageConfig(response_);
      })).pipe(_observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
              try {
                  return this.processDeleteMMessageConfig(response_ as any);
              } catch (e) {
                  return _observableThrow(e) as any as Observable<void>;
              }
          } else
              return _observableThrow(response_) as any as Observable<void>;
      }));
    }

    protected processDeleteMMessageConfig(response: HttpResponseBase): Observable<void> {
      const status = response.status;
      const responseBlob =
          response instanceof HttpResponse ? response.body :
          (response as any).error instanceof Blob ? (response as any).error : undefined;

      let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
      if (status === 200) {
          return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
          }));
      } else if (status === 400) {
          return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
          let result400: any = null;
          result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
          return throwException("400 response", status, _responseText, _headers, result400);
          }));
      } else if (status === 500) {
          return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
          let result500: any = null;
          result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
          return throwException("500 response", status, _responseText, _headers, result500);
          }));
      } else if (status === 404) {
          return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
          let result404: any = null;
          result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
          return throwException("404 response", status, _responseText, _headers, result404);
          }));
      } else if (status === 504) {
          return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
          let result504: any = null;
          result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorDto;
          return throwException("504 response", status, _responseText, _headers, result504);
          }));
      } else if (status !== 200 && status !== 204) {
          return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          }));
      }
      return _observableOf<void>(null as any);
    }

    /**
     * @return 200 response
     */
    mmessageConfig(): Observable<void> {
        let url_ = this.baseUrl + "/mmessage-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMmessageConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMmessageConfig(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMmessageConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sortOrder (optional)
     * @param searchAfterTime (optional)
     * @param address (optional)
     * @param city (optional)
     * @param isMapped (optional)
     * @param searchAfterId (optional)
     * @param postalCode (optional)
     * @param size (optional)
     * @return 200 response
     */
    getNonmatchedAddresses(sortOrder: string | null | undefined, searchAfterTime: string | null | undefined, address: string | null | undefined, city: string[] | null | undefined, isMapped: string | null | undefined, searchAfterId: string | null | undefined, postalCode: string[] | null | undefined, size: string | null | undefined): Observable<NonmatchedAddressGetResponse> {
        let url_ = this.baseUrl + "/nonmatched-address?";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchAfterTime !== undefined && searchAfterTime !== null)
            url_ += "searchAfterTime=" + encodeURIComponent("" + searchAfterTime) + "&";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        if (city !== undefined && city !== null)
            city && city.forEach(item => { url_ += "city=" + encodeURIComponent("" + item) + "&"; });
        if (isMapped !== undefined && isMapped !== null)
            url_ += "isMapped=" + encodeURIComponent("" + isMapped) + "&";
        if (searchAfterId !== undefined && searchAfterId !== null)
            url_ += "searchAfterId=" + encodeURIComponent("" + searchAfterId) + "&";
        if (postalCode !== undefined && postalCode !== null)
            postalCode && postalCode.forEach(item => { url_ += "postalCode=" + encodeURIComponent("" + item) + "&"; });
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonmatchedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonmatchedAddresses(<any>response_);
                } catch (e) {
                    return <Observable<NonmatchedAddressGetResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<NonmatchedAddressGetResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetNonmatchedAddresses(response: HttpResponseBase): Observable<NonmatchedAddressGetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NonmatchedAddressGetResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonmatchedAddressGetResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    mapAddress(putNonMatchedAddressRequest: PutNonMatchedAddressRequest): Observable<PutNonMatchedAddressResponse> {
        let url_ = this.baseUrl + "/nonmatched-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(putNonMatchedAddressRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapAddress(<any>response_);
                } catch (e) {
                    return <Observable<PutNonMatchedAddressResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PutNonMatchedAddressResponse>><any>_observableThrow(response_);
        }));
    }

    protected processMapAddress(response: HttpResponseBase): Observable<PutNonMatchedAddressResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PutNonMatchedAddressResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("400 response", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PutNonMatchedAddressResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    nonmatchedAddress(): Observable<void> {
        let url_ = this.baseUrl + "/nonmatched-address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNonmatchedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNonmatchedAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNonmatchedAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return 200 response
     */
    getServiceArea(): Observable<ServiceAreaResponse> {
        let url_ = this.baseUrl + "/service-area";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceArea(<any>response_);
                } catch (e) {
                    return <Observable<ServiceAreaResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceAreaResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceArea(response: HttpResponseBase): Observable<ServiceAreaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceAreaResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("500 response", status, _responseText, _headers, result500);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result504: any = null;
            result504 = _responseText === "" ? null : <ErrorDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("504 response", status, _responseText, _headers, result504);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceAreaResponse>(<any>null);
    }

    /**
     * @return 200 response
     */
    serviceArea(): Observable<void> {
        let url_ = this.baseUrl + "/service-area";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceArea(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processServiceArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface AdHocNotificationPostResponse {
    result: AdHocNotificationResponse;
}
export interface ServiceAddress {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    state?: string | undefined;
    deviceId?: string | undefined;
}

export interface GetActiveAddressesRequest {
    idOnly?: boolean | undefined;
    searchCriteria?: any | undefined;
    sortOrder?: GetActiveAddressesRequestSortOrder | undefined;
    pageSize?: number | undefined;
    searchAfter?: string | undefined;
}

export interface ActiveAddress {
    zip: string;
    statusSource: string;
    address: string;
    city: string;
    addressKey: string;
    estimatedRestorationTimeSrc?: string | undefined;
    updatedOn: string;
    id: string;
    sectionalizationDeviceId: string;
    estimatedRestorationTime?: string | undefined;
    status: string;
}

export interface AffectedAreaResponseV2 {
    result?: AffectedAreaV2 | undefined;
}

export interface PostAffectedAddressRequest {
    mutePushNotificationToggle?: boolean | undefined;
    mMessage: string;
    serviceAddress?: ServiceAddress | undefined;
    estimatedRestorationTime?: string | undefined;
}

export interface AffectedAreaV2 {
    pspsOutage: number[][];
    atRisk: number[][];
}

export interface NonmatchedAddressGetResponse {
    result?: Result | undefined;
}

export interface BlockedAddressItem {
    eventId?: string | undefined;
    addressKey?: string | undefined;
    postalCode?: string | undefined;
    updatedOn?: string | undefined;
    id: string;
    createdOn?: string | undefined;
}

export interface PSPSEventStatus {
    id?: string | undefined;
    startedOn?: string | undefined;
    status?: PSPSEventStatusStatus | undefined;
}

export interface ActiveAddressesResponse {
    result: Result2;
}

export interface PutNonMatchedAddressRequest {
    address: any;
    googlePlaceId: string;
    nonMatchedAddressKeys: any[];
}

export interface NonMatchedAddressItem {
    address?: string | undefined;
    city?: string | undefined;
    isMapped?: boolean | undefined;
    postalCode?: string | undefined;
    updatedOn?: string | undefined;
    state?: string | undefined;
    id: string;
    mappedAddress?: string | undefined;
}

export interface AddressAttributeResponse {
    result: AddressAttribute;
}

export interface AffectedAddress {
    statusSource?: string | undefined;
    updatedOn?: string | undefined;
    id: string;
    createdOn?: string | undefined;
    estimatedRestorationTime?: string | undefined;
    sectionalizationDeviceId?: string | undefined;
    status: AffectedAddressStatus;
    trackerText?: string | undefined;
}

export interface AffectedArea {
    area: number[][];
}

export interface DeleteBlockedAddressRequest {
    ids?: any[] | undefined;
}

export interface PostAffectedAddressResult {
    eventId?: string | undefined;
    statusSource?: string | undefined;
    updatedBy?: string | undefined;
    addressKey?: string | undefined;
    placeId?: string | undefined;
    estimatedRestorationTimeSrc?: string | undefined;
    updatedOn?: string | undefined;
    createdOn?: string | undefined;
    ingestedAddress?: IngestedAddress | undefined;
    createdBy?: string | undefined;
    location?: Location | undefined;
    id?: string | undefined;
    sectionalizationDeviceId?: string | undefined;
    estimatedRestorationTime?: string | undefined;
    status?: PostAffectedAddressResultStatus | undefined;
}

export interface BulkOperationResponse {
    result: Result3;
}

export interface AddressAggregate {
    count: number;
    key: string;
}

export interface PSPSEventStatusResponse {
    result: PSPSEventStatus;
}

export interface PatchAffectedAddressRequest {
    mutePushNotificationToggle?: boolean | undefined;
    updates: PatchAffectedAddressItem[];
}

export interface ActiveAddressSortKey {
    last: string;
    first: string;
}

export interface HealthStatus {
    exampleExternalResponseTime?: string | undefined;
    component2Status?: string | undefined;
    version?: string | undefined;
    executionTime?: number | undefined;
    dbResponseTime?: string | undefined;
    logLevel?: string | undefined;
    environmentName?: string | undefined;
    component2ResponseTime?: string | undefined;
    dbStatus?: string | undefined;
    region?: string | undefined;
    exampleExternalStatus?: string | undefined;
    errors?: any[] | undefined;
    status?: string | undefined;
}

export interface ErrorDto {
    data?: any | undefined;
    errorCode?: number | undefined;
    message?: string | undefined;
}

export interface NonMatchedAddressSortKey {
    last: any[];
    first: any[];
}

export interface PostAffectedAddressResponse {
    result?: PostAffectedAddressResult | undefined;
}

export interface AddressHistoryResult {
    addressHistory: AddressHistory[];
}

export interface PatchAffectedAddressItem {
    property: string;
    id: string;
    value: string;
}

export interface AddressAttribute {
    values: AddressAggregate[];
    property: string;
}

export interface AffectedAreaResponse {
    result?: AffectedArea | undefined;
}
export interface AdHocNotification {
    language: string;
    body: string;
    title: string;
}
export interface AdHocNotificationPostRequest {
    addressKeys: any[];
    adHocNotification: AdHocNotification[];
}

export interface PutNonMatchedAddressResponse {
    result: any[];
}

export interface ServiceAreaResponse {
    result: ServiceArea;
}

export interface GetBlockedAddressResponse {
    result: BlockedAddressItem[];
}

export interface HealthStatusResponse {
    result: HealthStatus;
}

export interface PostBlockedAddressRequest {
    blockPermanently?: boolean | undefined;
    postalCodes?: any[] | undefined;
    addressKeys?: any[] | undefined;
}

export interface AffectedAddressResponse {
    result: AffectedAddress[];
}

export interface ServiceArea {
    postalCodes: any[];
    bounds: Bounds;
}

export interface MMessageConfigResponse {
    result: MMessageConfig[];
}

export interface AdHocNotificationResponse {
    itemsWithErrors: number;
    itemsProcessed: number;
    errors: string[][];
}

export interface MMessageConfig {
    ertAllowed: boolean;
    ingestionEnabled: boolean;
    canStartPsps: boolean;
    id: string;
    language: string;
    status: string;
    trackerText?: string | undefined;
    createdOn?: string | undefined;
    updatedOn?: string | undefined;
}

export interface PutMMessageConfigRequest {
    ertAllowed: boolean;
    ingestionEnabled: boolean;
    canStartPsps: boolean;
    status: string;
    trackerText?: string | undefined;
}

export interface PostMMessageConfigRequest {
    ertAllowed: boolean;
    ingestionEnabled: boolean;
    canStartPsps: boolean;
    id: string;
    language: string;
    status: string;
    trackerText?: string | undefined;
}

export interface AddressHistoryResponse {
    result: AddressHistoryResult;
}

export enum GetActiveAddressesRequestSortOrder {
    Asc = "asc",
    Desc = "desc",
}
export interface Result {
    total: number;
    addresses: NonMatchedAddressItem[];
    sortKey?: NonMatchedAddressSortKey | undefined;
}

export enum PSPSEventStatusStatus {
    NoEvent = "NoEvent",
    PSPSEventInProgress = "PSPSEventInProgress",
}

export interface Result2 {
    total: number;
    addresses: ActiveAddress[];
    sortKey?: ActiveAddressSortKey | undefined;
}

export enum AffectedAddressStatus {
    NoEvent = "NoEvent",
    PotentialOutage = "PotentialOutage",
    PSPSOutage = "PSPSOutage",
    UnplannedOutage = "UnplannedOutage",
    OnPatrol = "OnPatrol",
    PowerRestored = "PowerRestored",
    AssessingOutage = "AssessingOutage",
}

export interface IngestedAddress {
    address: string;
    city: string;
    postalCode: string;
    state: string;
    deviceId: string;
}

export interface Location {
    lon: number;
    lat: number;
}

export enum PostAffectedAddressResultStatus {
    NoEvent = "NoEvent",
    PotentialOutage = "PotentialOutage",
    PSPSOutage = "PSPSOutage",
    UnplannedOutage = "UnplannedOutage",
    OnPatrol = "OnPatrol",
    PowerRestored = "PowerRestored",
    AssessingOutage = "AssessingOutage",
}

export interface Result3 {
    itemsWithErrors: number;
    itemsProcessed: number;
    errors: string[][];
}

export interface AddressHistory {
    statusSource: string;
    updatedBy: string;
    addressKey: string;
    createdBy: string;
    estimatedRestorationTimeSrc: string;
    updatedOn: string;
    id: string;
    isActive: string;
    createdOn: string;
    sectionalizationDeviceId: string;
    estimatedRestorationTime: string;
    status: string;
}

export interface Bounds {
    east: number;
    south: number;
    north: number;
    west: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
